export default __webpack_public_path__ + "assets/errorGraphic.a01e4073.svg";